import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { IUser, IWorkspace, WORKSPACE_TYPE } from '../models/model';
import { AuthenticationService } from '../services/authentication.service';
import { OrganizationSetupFormService } from '../../contract-management/services/organization-setup-from.service';


@Injectable({ providedIn: 'root' })
export class PermissionGuard implements CanActivate {
    currentUser!: IUser | null | undefined
    currentWorkspace!: IWorkspace | null | undefined

    constructor(
        private router: Router,
        private authService: AuthenticationService,
        private organizationService: OrganizationSetupFormService,
    ) {
        this.authService.currentUser.subscribe(res => {
            this.currentUser = res
        });
        this.organizationService.currentWorkspace.subscribe(res => {
            this.currentWorkspace = res
        });
    }

    private checkPermission(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        let hasPermission = true
        if (route.data?.['roles']) {
            hasPermission = route.data?.['roles'].includes(this.currentUser?.role)
        }
        if (this.currentWorkspace?.type === WORKSPACE_TYPE.CUSTOM && route.data?.['workspaceRoles']) {
            hasPermission = route.data?.['workspaceRoles'].includes(this.currentUser?.workspaceRole)
        }
        if (!hasPermission)
            this.router.navigate(['']);
        return hasPermission
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        return this.checkPermission(route, state)
    }
}
